import StagesMortgagesWidget from './Different-Widgets/stagesMortgagesWidget';
import PersonalAnalyst from './Different-Widgets/personalAnalyst';

export const types = {
	OPERATION_STAGES: StagesMortgagesWidget,
	PERSONAL_ANALYST: PersonalAnalyst
};
